module.exports = __webpack_public_path__ + "static/media/58.0cca0142.png";